import { render, staticRenderFns } from "./IngresoEstampillasTab.vue?vue&type=template&id=1c4b0b14&scoped=true&"
import script from "./IngresoEstampillasTab.vue?vue&type=script&lang=js&"
export * from "./IngresoEstampillasTab.vue?vue&type=script&lang=js&"
import style0 from "./IngresoEstampillasTab.vue?vue&type=style&index=0&id=1c4b0b14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4b0b14",
  null
  
)

export default component.exports